export const footerUrls = {
	CONTACT_US: 'https://service.shure.com/s/contact-us?language={LANGUAGE_CODE}&region={REGION_CODE}',
	SHURE_CLOUD_FAQ: 'https://service.shure.com/s/global-search/ShureCloud?language=en_US',
	IMPRINT: '/imprint',
	TERMS_CONDITIONS: 'https://www.shure.com/{LANGUAGE_CODE}/legal',
	PRIVACY_POLICY: 'https://www.shure.com/{LANGUAGE_CODE}/legal/privacy',
	COOKIE_POLICY: 'https://www.shure.com/{LANGUAGE_CODE}/legal/cookies',
	LEARN_ABOUT_SHURE_ID: 'https://www.shure.com/{LANGUAGE_CODE}/support/shurecloud'
};
